export { default } from "./ClickableText";
